<app-util-visitor-parts-treatment-per-os-list-items
                            [visitor]="visitor"
                            [archived]="archived"
                            [limit]="limit"
                            (updateEvent)="update()"
                            #utilVisitorPartsTreatmentPerOsListItems></app-util-visitor-parts-treatment-per-os-list-items>